import { GALLERY_CONSTS } from 'pro-gallery'; // use base styles

export var fixedStyles = {
  desktopExpand: {
    galleryLayout: GALLERY_CONSTS.layout.SLIDESHOW,
    slideAnimation: GALLERY_CONSTS.slideAnimations.FADE,
    arrowsPosition: GALLERY_CONSTS.arrowsPosition.OUTSIDE_GALLERY,
    itemClick: GALLERY_CONSTS.itemClick.NOTHING,
    slideshowInfoSize: 0,
    cubeType: GALLERY_CONSTS.cubeType.FIT
  },
  desktopFullscreen: {
    galleryLayout: GALLERY_CONSTS.layout.SLIDESHOW,
    slideAnimation: GALLERY_CONSTS.slideAnimations.FADE,
    itemClick: GALLERY_CONSTS.itemClick.NOTHING,
    arrowsPosition: GALLERY_CONSTS.arrowsPosition.ON_GALLERY,
    slideshowInfoSize: 0,
    cubeType: GALLERY_CONSTS.cubeType.FIT
  },
  mobileExpand: {
    galleryLayout: GALLERY_CONSTS.layout.SLIDESHOW,
    slideAnimation: GALLERY_CONSTS.slideAnimations.SCROLL,
    showArrows: false,
    slideshowInfoSize: 0,
    cubeType: GALLERY_CONSTS.cubeType.FIT,
    itemClick: GALLERY_CONSTS.itemClick.NOTHING,
    videoPlay: GALLERY_CONSTS.videoPlay.AUTO,
    hidePlay: false,
    showVideoPlayButton: true
  },
  mobileFullscreen: {
    galleryLayout: GALLERY_CONSTS.layout.SLIDESHOW,
    slideAnimation: GALLERY_CONSTS.slideAnimations.SCROLL,
    itemClick: GALLERY_CONSTS.itemClick.NOTHING,
    showArrows: false,
    slideshowInfoSize: 0,
    cubeType: GALLERY_CONSTS.cubeType.FIT
  }
};